<template>
  <div>
    <h2 class="title is-2">
      Favourites
    </h2>

    <div class="is-fullwidth">
      <b-notification
        v-if="loaded && favourites.length === 0"
        :closable="false"
      >
        You have no favourites.
      </b-notification>

      <div v-if="loaded && favourites.length > 0">
        <track-list-item
          v-for="fave in $store.getters['favouriteTracks/favouriteTracks']"
          :key="fave.pk"
          :track="fave.item"
          :show-waveform="false"
        >
          <div
            style="width: 150px; padding-left: 20px;"
            class="column is-narrow text small color-bluegrey3 is-hidden-mobile"
          >
            Added {{ fave.created_at|formattedDate }}
          </div>
          <div class="column is-narrow">
            <a
              class="icon-button heart-active"
              @click="handleFavouriteDelete(fave.pk)"
            />
          </div>
        </track-list-item>
      </div>

      <div
        v-if="!loaded"
        class="columns"
      >
        <div class="column is-12 has-text-centered">
          <br>
          <span
            class="loader xl"
            style="display: inline-block; width: 3em; height: 3em;"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import favouritesClient from '@/api/favouriteTracks.js'
import TrackListItem from '@/components/TrackListItem.vue'

export default {
  name: 'FavouriteTracksList',

  components: {
    TrackListItem
  },

  data () {
    return {
      loaded: false
    }
  },

  computed: {
    favourites: function () {
      return this.$store.getters['favouriteTracks/favouriteTracks']
    },
    user: function () {
      return this.$store.getters['user/currentUser']
    },
    fullName: function () {
      return this.$store.getters['user/fullName']
    }
  },

  created () {
    this.$store
      .dispatch('favouriteTracks/fetchFavouriteTracks')
      .then(favourites => {
        this.loaded = true
        const tracks = favourites.map(fave => fave.item)
        if (tracks.length > 0) {
          this.$store.dispatch('player/loadTracks', tracks)
        }
      })
  },

  methods: {
    trackRouteTo: function (track) {
      return {
        name: 'track-detail',
        params: {
          slug: track.slug,
          artistSlug: track.artist.slug,
          trackId: track.pk
        }
      }
    },

    handleFavouriteDelete (favePk) {
      this.$store.dispatch('favouriteTracks/removeFromFavouriteTracks', favePk)
      favouritesClient.delete(favePk)
    }
  },

  metaInfo: {
    title: 'Favourites'
  }
}
</script>

<style>
</style>
